import React, { Component } from 'react';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  Badge
} from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { auth } from './base';

import AuthProvider from './AuthProvider';
import actions from './actions';

const MENU = {
  '/': { to: '/', label: 'Início', className: 'd-block d-md-none' },
  '/admin': {
    to: '/admin',
    label: 'Administração',
    roles: ['admin', 'sindico', 'conselheiro'],
    options: [
//      { to: '/admin/responder-problema', label: 'Responder problema', roles: ['admin', 'sindico', 'conselheiro'] },
      { to: '/admin/contatos', label: 'Contatos', roles: ['admin', 'sindico', 'conselheiro'] },
      { to: '/admin/outros', label: 'Outros', roles: ['admin'] }
    ]
  },
  '/agua-mineral': {
    to: '/agua-mineral',
    label: 'Água Mineral',
    badge: false,
    roles: ['agua-mineral']
  },
  '/notificacoes': {
    to: '/notificacoes',
    label: 'Notificações',
    roles: ['admin', 'sindico', 'conselheiro', 'porteiro', 'zelador', 'morador', 'proprietario', 'agua-mineral'],
    options: [
      { to: '/notificacoes/configuracoes', label: 'Configurações', roles: ['admin', 'sindico', 'conselheiro', 'porteiro', 'zelador', 'morador', 'proprietario', 'agua-mineral'] },
    ]
  },
/*   '/reportar-problema': {
    to: '/reportar-problema',
    label: 'Reportar problema',
    roles: ['admin', 'sindico', 'conselheiro', 'porteiro', 'zelador', 'morador', 'proprietario']
  },
 */  '/reservas': {
    to: '/reservas',
    label: 'Reservas',
    badge: true,
    roles: [
      'admin',
      'sindico',
      'conselheiro',
      'porteiro',
      'zelador',
      'proprietario',
      'morador'
    ]
  },
  '/registro-acesso': {
    to: '/registro-acesso',
    label: 'Registro de Acesso',
    badge: true,
    roles: ['admin', 'sindico', 'conselheiro', 'porteiro', 'zelador']
  },
  '/mudancas': {
    to: '/mudancas',
    label: 'Mudanças',
    badge: false,
    roles: ['admin', 'sindico', 'conselheiro', 'porteiro', 'zelador']
  },
  '/achados': {
    to: '/achados',
    label: 'Achados & Perdidos',
    badge: false,
    roles: ['admin', 'sindico', 'conselheiro', 'proprietario', 'morador', 'porteiro', 'zelador']
  },
  '/consumo': {
    to: '/consumo',
    label: 'Consumo',
    badge: false,
    roles: ['proprietario', 'morador']
  },
   '/agenda': {
    to: '/agenda',
    label: 'Agenda',
    badge: false,
    roles: ['admin', 'sindico', 'conselheiro', 'porteiro', 'zelador'],
    options: [
      { to: '/agenda/tarefas', label: 'Tarefas', roles: ['admin', 'sindico', 'conselheiro'] },
      { to: '/agenda/qrcode', label: 'Confirmação', roles: ['admin', 'sindico', 'conselheiro'] },
    ]
  },
  '/unidade': {
    to: '/unidade',
    label: 'Unidade',
    badge: false,
    roles: ['morador']
  },
  '/entrar': {
    to: '/entrar',
    label: 'Entrar',
    hidden: ({ fetching }) => 0 === fetching
  }
};

class Cabecalho extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      collapsed: true,
      dropdownOpen: {}
    };
  }

  toggle() {
    this.setState(state => ({
      collapsed: !state.collapsed
    }));
  }

  close() {
    this.setState({
      collapsed: true
    });
  }

  activePage() {
    let {
      location: { pathname }
    } = this.props;

    if (pathname in MENU) {
      return MENU[pathname];
    } else {
      let foundIndex = pathname.indexOf("/", 1);
      if (-1 < foundIndex) {
        let parent = MENU[pathname.substr(0, foundIndex)];
        if (!parent.options) {
          return parent;
        }
        return parent
        .options
        .find(v => v.to === pathname);
      }
    }
    return ({
      to: pathname,
      label: 'Diego Rivera'
    });
  }

  isOpen (i) {
    return this.state.dropdownOpen[i];
  }

  toggleDropdown (i) {
    return () => this.setState(state => ({
      dropdownOpen: {
        ...state.dropdownOpen,
        [i]: !state.dropdownOpen[i]
      }
    }));
  }

  render() {
    let { badges, actions } = this.props;
    let { collapsed } = this.state;

    let ativo = this.activePage();

    return (
      <div className="header">
        <div className="menu main-menu">
          <div className="container">
            <Navbar
              color="faded"
              dark
              expand="xl"
              className="navbar-default app-menu">
              <NavbarToggler onClick={this.toggle} />
              {[
                {
                  to: '/',
                  label: 'Diego Rivera',
                  className: 'd-none d-xl-block'
                },
                { ...ativo, className: 'd-xl-none' }
              ].map(({ label, badge, hidden, ...otherProps }, i) => (
                <NavbarBrand key={i} tag={Link} {...otherProps}>
                  {label}
                </NavbarBrand>
              ))}
              <Collapse isOpen={!collapsed} navbar>
                <AuthProvider>
                  {({ auth: activeAuth }, containsRole) => (
                    <Nav className="xl-auto" navbar>
                      {Object.values(MENU).map(
                        (
                          {
                            label,
                            to,
                            badge,
                            options = [],
                            roles = [],
                            hidden,
                            ...otherProps
                          },
                          i
                        ) => {
                          let filteredOptions = options.filter(v => containsRole(v.roles));
                          return label &&
                            (!hidden || hidden(activeAuth)) &&
                            (!roles.length || containsRole(roles)) && (<ButtonDropdown key={i} nav isOpen={this.isOpen(i)} toggle={this.toggleDropdown(i)}>
                              <NavItem
                                active={ativo.label === label}
                                {...otherProps}
                                onClick={() => this.close()}
                                tag="span">
                                <NavLink tag={Link} to={to}>
                                  {label + ' '}
                                  {badge && (
                                    <Badge
                                      pill
                                      color={
                                        0 < badges[to] ? 'danger' : 'secondary'
                                      }>
                                      {badges[to]}
                                    </Badge>
                                  )}
                                </NavLink>
                              </NavItem>
                              {0 < filteredOptions.length && <DropdownToggle nav id={"toggleCabecalho" + i} caret color="link" />}
                              <DropdownMenu>
                                {filteredOptions.map((vv, i) => (<DropdownItem key={i} tag={Link} to={vv.to} onClick={() => this.close()}>{vv.label}</DropdownItem>))}
                              </DropdownMenu>
                            </ButtonDropdown>);
                      })}
                      {2 === activeAuth.fetching && (
                        <NavItem onClick={() => auth.signOut()}>
                          <NavLink tag={Link} to="#">
                            Sair
                          </NavLink>
                        </NavItem>
                      )}
                    </Nav>
                  )}
                </AuthProvider>
              </Collapse>
              <Nav navbar>
                <NavItem
                  className="app-button-help"
                  onClick={() => actions.abrirGuia()}
                >
                  <NavLink tag={Link} to="#">
                    <span className="fa fa-question" />
                  </NavLink>
                </NavItem>
              </Nav>
            </Navbar>
          </div>
        </div>
      </div>
    );
  }
}

let mapStateToProps = ({
  reserva: { list },
  registroAcesso: { presencas }
}) => ({
  badges: [
    ['/reservas', list.result.filter(v => -1 !== v.status).length],
    ['/registro-acesso', presencas.result.length]
  ].reduce((prev, curr) => {
    prev[curr[0]] = curr[1];

    return prev;
  }, {})
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Cabecalho)
);



// WEBPACK FOOTER //
// ./src/Cabecalho.js